/**
 * @author HungNS
 */
/* eslint-disable no-unused-vars */
import IConstants from "@/common/constants/IConstants.js";

const ModalPlugin = {
    install(Vue, options) {
        this.EventBus = new Vue();
        Vue.prototype.$modal = {
            pluginInstance: ModalPlugin.EventBus,
            showNewsInfo(options) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_NEWS_INFO, options);
            },
            showAgreementNewsModal(options) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_AGREEMENT_NEWS_MODAL, options);
            },
            searchBankVeritrans(options) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SEARCH_BANK_VERITRANS, options);
            },
            emitGetBankInfo(bankInfo) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.GET_SELECTED_BANK, bankInfo);
            },
            modalConfirm(params, screen) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.MODAL_CONFIRM, params, screen);
            },
            closeModalConfirm(params, forScreen) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + forScreen, params);
            },
            openServerErrorModal(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.OPEN_SERVER_ERROR_MODAL, params);
            },
            closeServerErrorModal(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.CLOSE_SERVER_ERROR_MODAL, params);
            },
            openSearchBank(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.OPEN_SEARCH_BANK, params);
            },
            afterSelectBank(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.AFTER_SELECT_BANK, params);
            },
            openSearchBranch(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.OPEN_SEARCH_BRANCH, params);
            },
            afterSelectBranch(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.AFTER_SELECT_BRANCH, params);
            },
            openInformModal(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.OPEN_INFORM_MODAL, params);
            },
            closeInformModal(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.CLOSE_INFORM_MODAL, params);
            },
            openUnsupportedBrowserModal(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.OPEN_UNSUPPORTED_BROWSER_MODAL, params);
            },
            showProfileMessage(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_PROFILE_MESSAGE, params);
            },
            showRegisterPasskeyResult(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_REGISTER_PASSKEY_RESULT, params);
            },
            retryRegisterPasskeyResult(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.RETRY_REGISTER_PASSKEY_RESULT, params);
            },
            closeRegisterPasskeySuccess() {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.CLOSE_REGISTER_PASSKEY_SUCCESS);
            },
            emitMaskingVerifyResult(screenName, params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.MASKING_VERIFY_RESULT + screenName, params);
            },
            showOtpMailChoosing(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_OTP_MAIL_CHOOSING, params);
            },
            showOtpInput(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_OTP_INPUT, params);
            },
            closeOtpInputResult(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.CLOSE_OTP_INPUT_RESULT, params);
            },
            showOtpInputResult(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_OTP_INPUT_RESULT, params);
            },
            showFidoAuthenticateUnsupported() {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_FIDO_AUTHENTICATE_UNSUPPORTED);
            },
            showConfirmDeletePasskey(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_CONFIRM_DELETE_PASSKEY, params);
            },
            showDeletePasskeyResult(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_DELETE_PASSKEY_RESULT, params);
            },
            showRegisterPasskeyModal(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_REGISTER_PASSKEY_MODAL, params);
            },
            hideRegisterPasskeyModal(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.HIDE_REGISTER_PASSKEY_MODAL, params);
            },
            showRegisterPasskeyModalResult(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.SHOW_REGISTER_PASSKEY_MODAL_RESULT, params);
            },
            retryRegisterPasskeyModalResult(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.RETRY_REGISTER_PASSKEY_MODAL_RESULT, params);
            },
            reloadRegisteredPasskeys() {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.RELOAD_REGISTERED_PASSKEYS);
            },
            reAssignProfileStateEvent(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.RE_ASSIGN_PROFILE_STATE_EVENT, params);
            },
            reAssignProfileStateAndReEmitMaskingVerifiedEvent(params) {
                ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.RE_ASSIGN_PROFILE_STATE_AND_RE_EMIT_MASKING_VERIFIED_EVENT, params);
            },
        };
    },
};

export default ModalPlugin;
